import { Plus } from 'components/Icons';
import styles from './styles.module.scss';
import classNames from 'classnames';
export const PillIconButton = (props) => {
  const { className, style, onClick, text, icon } = props;

  return (
    <div className={classNames(styles.pillIconButton, className)} style={style} onClick={onClick}>
      {icon || <Plus color="#515151" className={styles.addIcon} />}
      <div className={styles.text}>{text}</div>
    </div>
  );
};
